"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _SNETLogo = _interopRequireWildcard(require("../SNETLogo"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooterColumn = _ref => {
  let {
    column
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const columnClassName = column.isPrimary ? "".concat(classes.footerColumn, ", ").concat(classes.primary) : classes.footerColumn;
  const ColumnTitle = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, column.isPrimary ? /*#__PURE__*/_react.default.createElement(_SNETLogo.default, {
      variant: _SNETLogo.logoVariants.LIGHT,
      additionalClassName: classes.columnTitle
    }) : /*#__PURE__*/_react.default.createElement("h3", {
      className: classes.columnTitle
    }, column.title));
  };
  const ColumnLinks = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: classes.columnLinks
    }, column.links.map(link => /*#__PURE__*/_react.default.createElement("li", {
      key: link.key
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: link.href,
      className: classes.columnLink,
      target: "_blank",
      rel: "noreferrer"
    }, link.label)))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: columnClassName
  }, /*#__PURE__*/_react.default.createElement(ColumnTitle, null), /*#__PURE__*/_react.default.createElement(ColumnLinks, null)));
};
var _default = exports.default = SnetFooterColumn;